import { ReactElement } from 'react';

function PlanLoading(): ReactElement {
  return (
    <div className="flex w-full h-full justify-center items-center m-auto content-center self-center">
      <img className="w-6" src="/assets/images/spinner2.svg" alt="Loading" />
    </div>
  );
}

export default PlanLoading;
